/**
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 * Sectors - Rugengabari 
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 */
module.exports = {
  "Kilibata": ["Bushima", "Cyogo", "Murungu", "Musheke", "Remera", "Taba"],
  "Mucaca": ["Burago", "Burande", "Gahinga", "Kamonyi", "Karubamba", "Mugina", "Nkoto", "Nyabikungu", "Rihiro"],
  "Nyanamo": ["Bwenjeli", "Kabira", "Kabukoko", "Kabuyenge", "Kamonyi", "Kiziba", "Murambo", "Taba"],
  "Rukandabyuma": ["Gatenga", "Kinyefurwe", "Mubuga", "Murambo", "Ngoma", "Nyansyo", "Remya", "Rugandu", "Seta"]
};